import { processDelayedStoredLogs } from '@shared/extension/utils/stored-logs';
import { ONE_MINUTE_MS } from '@shared/utils/constants';
import { Services } from '../services';

const PROCESS_DELAYED_STORED_LOGS_INTERVAL = 5 * ONE_MINUTE_MS;

export function startHandlingStoredLogs(services: Services): void {
  setInterval(() => {
    processDelayedStoredLogs();
  }, PROCESS_DELAYED_STORED_LOGS_INTERVAL);

  services.networkService.isOnline$.subscribe(isOnline => {
    if (isOnline) {
      console.log(`Network is back, processing delayed stored logs`);
      processDelayedStoredLogs();
    }
  });
}
